<template>
    <div class="modal fade" tabindex="-1" :id="id">
      <div class="modal-dialog modal-lg">
        <form @submit.prevent="submitForm" class="form">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t("stats.setSize") }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                </svg>
              </span>
              </div>
            </div>
            <div class="modal-body">
              <div>
                <h4>{{ $t("stats.middleSize") }}</h4>
                <div class="col-6 rounded border position-relative" :class="{'active': column == MIDDLE_SIZE}" @click="column = MIDDLE_SIZE">
                  <div class="overlay">
                    <div class="form-check form-check-custom form-check-solid form-check-primary m-6 position-absolute top-5 left-5">
                        <input class="form-check-input" type="radio" name="plan" v-model="column" :value="MIDDLE_SIZE"/>
                    </div>
                    <div v-if="img" class="bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-150px" :style="{ backgroundImage: `url(${img})` }"></div>
                    <div v-else class="bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-150px" style="background-image:url('/assets/media/avatars/form.jpg');"></div>
                  </div>
                  
                </div>
              </div>
              <br><br>
              <div>
                <h4>{{ $t("stats.fullSize") }}</h4>
                <div class="col-12 rounded border" :class="{'active': column == FULL_SIZE}" @click="column = FULL_SIZE">
                  <div class="overlay">
                    <div class="form-check form-check-custom form-check-solid form-check-primary m-6 position-absolute top-5 left-5">
                      <input class="form-check-input" type="radio" v-model="column" name="plan" :value="FULL_SIZE"/>
                    </div>
                    <div v-if="img" class="bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-150px" :style="{ backgroundImage: `url(${img})` }"></div>
                    <div v-else class="bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-150px" style="background-image:url('/assets/media/avatars/form.jpg');"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
              <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="processing"></Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  
</template>

<script setup>
import {ref, defineEmits, defineProps, computed, watch} from "vue";
import {useStore} from "vuex";
import Button from "@/components/Button"

const MIDDLE_SIZE = 1
const FULL_SIZE = 2

const emits = defineEmits(['closed'])

const store = useStore()
const props = defineProps({
  id: { type: String, required: true},
  img: { type: String, required: false},
  widget : { type: Object, required: true},
})

const processing = ref(false)
const column = ref(FULL_SIZE)

const widgets = computed(() => store.getters['stats/getWidgets'])


function submitForm() {
  processing.value = true
  
  store.dispatch('stats/saveWidget', {weight: column.value, widget_id: props.widget})
      .then(res => {
        loadData()
        closeModal()
        window.toastr['success'](i18n.global.t("notification.widgetSetted"))
      })
      .finally(() => {
        processing.value = false
        emits("closed")
      })
}

const closeModal = () => {
    emits("closed")
    $("#"+props.id).modal('toggle')
}
 
const loadData = () => {
  store.dispatch('stats/loadUserWidgets')
}

</script>
<style scoped>
.active{
  border: 1px solid var(--bs-primary) !important;
  border-radius: 8px;
}
</style>